import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root',
})
export class ConfirmService {
    /**
     * Displays a 3-state confirmation dialog.
     * @param message The message to display in the dialog.
     * @param title The title of the dialog.
     * @param options Optional configuration for button texts.
     * @returns A promise resolving to one of 'confirm', 'reject', or 'third'.
     */
    confirmWithThreeStates(message, titleOrCallback, callback, opts): Promise<any> {
        let title = '';

        if (typeof titleOrCallback === 'function') {
            callback = titleOrCallback;
        } else if (titleOrCallback) {
            title = titleOrCallback;
        }

        opts = opts || {};
        opts.title = title ? title : abp.localization.abpWeb('AreYouSure');
        opts.type = 'warning';

        opts.confirmButtonText = opts.confirmButtonText || abp.localization.abpWeb('Yes');
        opts.cancelButtonText = opts.cancelButtonText || abp.localization.abpWeb('Cancel');

        if (!opts.hideCancelBtn) {
            opts.showCancelButton = true;
        }

        if (opts.isHtml) {
            opts.html = message;
        } else {
            opts.text = message;
        }

        return Swal.fire(opts).then((result) => {
            callback(result);
        });
    }
}
